<template>
  <ReportPanel>
    <h6 class="q-mt-md">Please select the financial year you wish to generate the report for.</h6>

    <FinancialYearQuarterSelector
      :selected-financial-year="selectedFinancialYear"
      :selected-quarter="null"
      :financial-years="financialYears"
      :quarter-options="quarterOptions"
      :show-quarter="false"
      @update:selected-financial-year="selectedFinancialYear = $event"
    />

    <q-btn
      :loading="loading"
      label="Generate Elder Report"
      class="full-width"
      color="secondary"
      no-caps
      @click="generateElderReport"
    />
  </ReportPanel>
</template>

<script>
import api from "@/services/api/api";
import notify from "@/services/util/notify";
import { promptDownload } from "@/services/util/file";
import FinancialYearQuarterSelector from "./FinancialYearQuarterSelector.vue";
import ReportPanel from "./ReportPanel.vue";

export default {
  name: "ElderReportPanel",
  components: {
    FinancialYearQuarterSelector,
    ReportPanel
  },
  props: {
    financialYears: {
      type: Array,
      required: true
    },
    quarterOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      selectedFinancialYear: 2024
    }
  },
  methods: {
    async generateElderReport() {
      this.loading = true;

      try {
        const report = await api.reports.generateElderReport(this.selectedFinancialYear);
        promptDownload(report, `Elder Reporting FY${this.selectedFinancialYear}.xlsx`);
      } catch (error) {
        console.error(error);
        notify.error("There was an issue generating your elder report.");
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
